module.exports = __webpack_public_path__ + "static/media/providerInfo1.474a8ee0.svg";